
import React, { useState , useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import FavoriteItem from "./FavoriteItem";
import SearchItem from "./SearchItem";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import  { loaderBar , apibaseURl , currencySymbol , errorToast , successToast , loggedInCustomerDetails }  from "../../functions/Function";


const Favorite = (props) => {
  const [isloader, setIsloader] = useState(true); 
  const [data, setData] = useState({});
  const [searchresult, setSearchresult] = useState({});
  const [issearch, setIssearch] = useState(false);
  const [addfav, setAddfav] = useState(true);
  const [searchtext, setSearchtext] = useState('');
  const [favitems, setFavitems] = useState({});
  const timer = () =>{
        setTimeout(() => {
        setIsloader(false);
      }, 1000);
  } 
  
  const fetchData = () => {
    fetch(apibaseURl + "favorite?user_id="+loggedInCustomerDetails('id'))
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            setData(result.response);
            var  items = {};
            if(Object.keys(data).length > 0)
            {   
                data.map((row, i) => (
                    items[row.product_id]   =  row.product_id 
                )) 
            }
            setFavitems(items);
            timer()
        }
      }
      )
  }

  const searchprodcut = (s='') => {
    fetch(apibaseURl + "search?s="+s)
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            setSearchresult(result.response);
            
        }
      }
      )
  }

  const searchActive = () => {
        setIssearch(true);
        setAddfav(false)
  }

  const handleClickFav = () => {
    fetchData();
    setIssearch(false);
    setAddfav(true)
    setSearchtext('');
    setSearchresult({});
    
 }

 const handleAddMoreFav = () => {
    setIssearch(true);
    setSearchtext('');
    setSearchresult({});
 }

const HandleDeleteFavItem = async (id = '' ,  key='') => {
    
    const resJson = DeleteFavItem(id);
    resJson.then(function (output) {
        if (output.result == true) {
            fetchData();
            successToast('Product has been removed from favorite list' , 'bottom-right' , 1500  , true);     
        }
    });


  }
  const DeleteFavItem = async (id = '') => {
    const res = await fetch(apibaseURl + "removefavoriteitem", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ favorite_id: id }),
    });
    let resJson = await res.json();
    return resJson;
  }
 

 useEffect(() => {
    handleClickFav();
    fetchData();
   }, [props.active])


   useEffect(() => {
    searchprodcut(searchtext);
   }, [searchtext])

    return (
        <>
           
            <ToastContainer />
            {props.active == 'fav' ? 
                <div>
                    {isloader == true && loaderBar(300 , 25) }
                    {issearch == true && 
                    <div>
                        <form>
                        <input className="form-control serch-middle-left"
                        type="search"
                        value={searchtext}
                        onChange={(e)=>setSearchtext(e.target.value)}
                        placeholder="Search"
                        aria-label="Search"  />
                        </form> 
                                
                        {searchtext == '' &&
                            <div className="not-found-itme-list ">
                                <div className="text-center">
                                <span className="star-not-icon"><i className="fa-solid fa-magnifying-glass"></i></span>
                                <p className="ivo-para">
                                        Search to add the product to favorite list
                                </p>
                                <button className="btn ivo-site-btn ivo-site-btn-v-2" 
                                onClick={ () => handleClickFav() }>  Back To Favorite List </button>
                                </div>
                            </div> 
                        }

                        {searchtext != '' && 
                            <div>       
                                        {Object.keys(searchresult).length > 0 ?
                                        <div>
                                            <div className="middle-left-content">
                                            <div><small><b>Name</b></small></div>
                                            <div  onClick={ () => handleClickFav() }><small><b>Back To List</b></small></div>
                                            </div>
                                            <ul className="ivo-left-index-ul adding-item-list  scroll-bar">
                                                
                                            {searchresult.map((row, i) => (
                                                <>
                                                    <SearchItem row={row} favitems={favitems} 
                                                    fill={favitems && favitems[row.id] ? true: false} />
                                                    
                                                </>
                                                
                                            )) }
                                            
                                            </ul>
                                        </div>
                                    : 
                                        <div className="not-found-itme-list ">
                                        <div className="text-center">
                                        <span className="star-not-icon"><i className="fa-solid fa-magnifying-glass"></i></span>
                                        <p className="ivo-para">
                                                Opps product cant found
                                        </p>
                                        <button className="btn ivo-site-btn ivo-site-btn-v-2" 
                                                onClick={ () => handleClickFav() }>  Back To Favorite List </button>
                                        </div>
                                        </div> 
                                    }
                            </div> 
                        }
                    </div>
                    }



                    {Object.keys(data).length > 0 && issearch == false &&  isloader == false && 
                    <div>
                    <div className="add-more-btn text-right">
                        <Link onClick={() =>handleAddMoreFav()} className="add-more-text" ><i className="fa-solid fa-plus"></i> Add Favorite
                        </Link>
                    </div>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="middle-left-content">
                            <div><small><b>Product Name</b></small></div>
                            <div><small><b>Price /  {currencySymbol()} </b></small></div>
                        </div>

                        <div className="tab-pane fade show active" id="nav-favouirte" role="tabpanel"
                            aria-labelledby="nav-favourite-tab">
                            <ul className="ivo-left-index-ul hovered-list-item scroll-bar">
                                {data.map((row, i) => (
                                        <FavoriteItem key={i} arr={i}  product={row} HandleDeleteFavItem={HandleDeleteFavItem}  handleClickActiveProduct={props.handleClickActiveProduct} />
                                )) }
                            </ul>

                        </div>

                    </div>
                    </div>
                    }
                    {Object.keys(data).length == 0  && addfav == true && isloader == false &&
                        <div className="not-found-itme-list ">
                            <div className="text-center">
                            <span className="star-not-icon"><i className="fa-regular fa-star"></i></span>
                            <p className="ivo-para">
                                You haven't added any favorites yet
                            </p>
                            <button className="btn ivo-site-btn ivo-site-btn-v-2" 
                            onClick={ () => searchActive() }> <i className="fa-solid fa-plus" ></i> Add Favorite </button>
                            </div>
                        </div> 
                    }
                </div>
            : ''}
        </>

    );
}

export default Favorite;
